/* ------------------------ tQuery ---------------------------
  tQuery is lightweight jquery substitute. Please keep it as such one.

  Available param types:
  1. id selector example: $t('#selector');
  2. already selected node object example: $t(document.querySelector('#selector'))
*/

/* ---- Animation Module ---- */
class TAnimation {
  constructor(element) {
    this.element = element;
    this.previousState = null;
  }

  fadeIn(displayProp = 'block') {
    this.element.style.display = displayProp;
    this.element.animationRunning = true;
    this.element.style.opacity = this.element.style.opacity ? this.element.style.opacity : 0;
    this.fadeInExec();
  }

  fadeInExec() {
    let val = parseFloat(this.element.style.opacity);

    if (!((val += 0.1) > 1)) {
      this.element.style.opacity = val;
      requestAnimationFrame(() => this.fadeInExec());
    } else {
      this.element.animationRunning = false;
    }
  }

  fadeOut() {
    this.element.style.opacity = this.element.style.opacity ? this.element.style.opacity : 1;
    const intervalId = setInterval(() => {
      if (!this.element.animationRunning) {
        clearInterval(intervalId);
        this.fadeOutExec();
      }
    }, 100);
  }

  fadeOutExec() {
    this.element.animationRunning = true;
    if ((this.element.style.opacity -= 0.1) < 0) {
      this.element.style.display = 'none';
      this.element.animationRunning = false;
    } else {
      requestAnimationFrame(() => this.fadeOutExec());
    }
  }

  show() {
    this.element && (this.element.style.display = this.previousState || 'block');
  }

  hide() {
    if (this.element) {
      this.previousState = this.element.style.display;
      this.element.style.display = 'none';
    }
  }
}

window.$t = function (selector) {
  let objects = [];
  const targetElement = typeof selector === 'object' ? selector : document.querySelector(selector);
  objects.find(object => {
    return object.element === targetElement;
  });
  const object = new TAnimation(targetElement);
  objects.push(object);

  return object;
};
export default TAnimation;
